//import AppConstant from '../../../config/app.constants';
import BaseController from '../common/location_zone.base.controller';

class LocationZoneEditController extends BaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, LocationZoneService, Modal, $translate, $q, $stateParams, CommonLayoutService, UserBranchService) {
        super(Auth, $state, User, LocationZoneService, Modal, $translate)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.Modal = Modal;
        this.$q = $q;
        this.$stateParams = $stateParams;
        this.CommonLayoutService = CommonLayoutService;
        this.UserBranchService = UserBranchService;
        this.branch = [];

        this.model = {
            currentBranch: this.User.getUser().branchId,
            LoggedInUser: this.User.getUser().id,
            loading: false,
            name: null,
            description: null,
            defaultBranch: null,
        }
        this.locationZoneTypes = this.CommonLayoutService.locationZoneTypes();
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
        this.clearErrors();
    }

    $onInit() {
        this.model.loading = true;
        this.$q.all([
            this.Service.get(this.$stateParams.id),
            this.UserBranchService.getUserBranches(this.model.LoggedInUser)
        ])
            .then((data) => {
                this.locationZoneObj = data[0].results;
                this.rawId = this.locationZoneObj.id;
                this.model.name = this.locationZoneObj.name;
                this.model.description = this.locationZoneObj.description
                this.model.type = this.locationZoneObj.type;
                this.model.branchId = this.locationZoneObj.branchId;
                this.model.createdAt = moment(this.locationZoneObj.createdAt).format('DD-MM-YYYY | hh:mm A');
                this.model.createdByUserId = this.concatUserName(this.locationZoneObj.createdByUserId, this.locationZoneObj.createdByUserId ? this.locationZoneObj.createdByUser.firstName : null, this.locationZoneObj.createdByUserId ? this.locationZoneObj.createdByUser.lastName : null);
                this.model.updatedAt = moment(this.locationZoneObj.updatedAt).format('DD-MM-YYYY | hh:mm A');
                this.model.modifiedByUserId = this.concatUserName(this.locationZoneObj.modifiedByUserId, this.locationZoneObj.modifiedByUserId ? this.locationZoneObj.modifiedByUser.firstName : null, this.locationZoneObj.modifiedByUserId ? this.locationZoneObj.modifiedByUser.lastName : null);
                this.defaultModel = this.model;
                data[1].results.map((b) => this.branch.push(b.branchId));
            })
            .catch((err) => {
                if (err && err.data && err.data.errors) {
                    err.data.errors.map((e) => {
                        this.errorMessage += e.message + '<br/>'
                    })
                }
                else if (err && err.data && err.data.message) {
                    this.errorMessage = err.data.message;

                }
                else {
                    this.errorMessage = err;
                }
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    concatUserName(id, firstName, lastName) {
        if (!id) return 'N/A';
        return id + ' | ' + firstName + ' ' + lastName;
    }

    update() {
        this.model.isUpdating = true;
        this.Service.update(this.rawId, {
            id: this.rawId,
            branchId: this.model.branchId,
            name: this.model.name,
            description: this.model.description,
            type: this.model.type,
            modifiedByUserId: this.model.LoggedInUser
        })
            .then(() => {
                window.history.go(-1);
            })
            .catch((err) => {
                if (err && err.data && err.data.errors) {
                    err.data.errors.map((e) => {
                        this.errorMessage += e.message + '<br/>'
                    })
                }
                else {
                    this.errorMessage = err.data.message;
                }
            })
            .finally(() => {
                this.model.isUpdating = false;
            })
    }


}

export default LocationZoneEditController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/location_zone/edit/location_zone.edit.controller.js